import React, {useState, useEffect} from 'react'
import {Box} from '@fuegokit/react'
import {StyledAvatar, StyledAvatarFallback, StyledAvatarImage} from '../../../src/components/Avatar/stories/StoryStyles'

const StyledAvatarExample = () => {
  const [domLoaded, setDomLoaded] = useState(false)

  useEffect(() => {
    setDomLoaded(true)
  }, [])
  return (
    <Box style={{display: 'flex', gap: 16}}>
      {domLoaded && (
        <StyledAvatar>
          <StyledAvatarImage
            src={'https://avatars.githubusercontent.com/u/128430248?s=128&v=4'}
            alt={'Masha Shaposhnikova'}
          />
          <StyledAvatarFallback delayMs={600}>MS</StyledAvatarFallback>
        </StyledAvatar>
      )}
    </Box>
  )
}
export default StyledAvatarExample
